import { Guid } from 'guid-typescript';

export class Species {
    id: Guid;
    code: string;
    description: string;
    deptSpeciesId: string;
    dataMarsSpeciesCode: string;
    active: boolean;
}